export default "338c566d7f991e56.png"